(function () {
  'use strict';

  const config = window.gommaDOT || {};
  config.exactSearchQuery = (value) => {
    const term = value.trim();
    if (/[":()*\\]/.test(term) || /\b(?:AND|OR|NOT)\b/.test(term) || parseTyreSize(term)) return term;
    const words = term.split(/\s+/);
    return words.length > 1 ? words.map((word) => `"${word}"`).join(' ') : term;
  };
  const liveRegion = () => document.getElementById('GommaDotLiveRegion');
  let toastTimer;

  // Mount explanations outside gallery/carousel overflow and keep them on screen.
  let activeSpecif = null;
  let specifTimer;
  let specifFrame;
  let specifId = 0;

  function closeSpecif() {
    window.clearTimeout(specifTimer);
    if (!activeSpecif) return;
    const { badge, tip } = activeSpecif;
    badge.classList.remove('is-open');
    badge.setAttribute('aria-expanded', 'false');
    tip.classList.remove('is-floating');
    tip.removeAttribute('style');
    badge.append(tip);
    activeSpecif = null;
  }

  function positionSpecif() {
    if (!activeSpecif) return;
    const { badge, tip } = activeSpecif;
    const rect = badge.getBoundingClientRect();
    const view = window.visualViewport;
    const left = (view?.offsetLeft || 0) + 12;
    const top = (view?.offsetTop || 0) + 12;
    const right = left + (view?.width || document.documentElement.clientWidth) - 24;
    const bottom = top + (view?.height || window.innerHeight) - 24;
    if (!badge.isConnected || rect.bottom < top || rect.top > bottom) {
      closeSpecif();
      return;
    }
    tip.style.width = `${Math.min(300, right - left)}px`;
    tip.style.maxHeight = `${Math.max(60, bottom - top)}px`;
    const size = tip.getBoundingClientRect();
    const x = Math.max(left, Math.min(rect.left, right - size.width));
    let y = rect.bottom + 8;
    if (y + size.height > bottom) y = rect.top - size.height - 8;
    y = Math.max(top, Math.min(y, bottom - size.height));
    tip.style.left = `${Math.round(x)}px`;
    tip.style.top = `${Math.round(y)}px`;
  }

  function openSpecif(badge, pinned = false) {
    window.clearTimeout(specifTimer);
    if (activeSpecif?.badge === badge) {
      activeSpecif.pinned ||= pinned;
      return;
    }
    closeSpecif();
    const tip = badge.querySelector('.specif-badge__tip');
    if (!tip) return;
    // The same product can appear in multiple carousels.
    if (!tip.dataset.positioned) {
      tip.id = `SpecifDescription-${++specifId}`;
      tip.dataset.positioned = 'true';
      badge.setAttribute('aria-describedby', tip.id);
    }
    activeSpecif = { badge, tip, pinned };
    badge.dataset.specifReady = 'true';
    badge.classList.add('is-open');
    badge.setAttribute('aria-expanded', 'true');
    tip.classList.add('is-floating');
    document.body.append(tip);
    positionSpecif();
  }

  function queueSpecifPosition(event) {
    if (!activeSpecif || (event.target instanceof Node && activeSpecif.tip.contains(event.target)) || specifFrame) return;
    specifFrame = requestAnimationFrame(() => {
      specifFrame = null;
      positionSpecif();
    });
  }

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    if (activeSpecif?.tip.contains(event.target)) window.clearTimeout(specifTimer);
    const badge = event.target.closest('[data-specif-badge]');
    if (badge && (!activeSpecif?.pinned || activeSpecif.badge === badge)) openSpecif(badge);
  });
  document.addEventListener('pointerdown', (event) => {
    if (activeSpecif && !activeSpecif.badge.contains(event.target) && !activeSpecif.tip.contains(event.target)) closeSpecif();
  });
  document.addEventListener('pointerout', (event) => {
    if (!activeSpecif || activeSpecif.pinned || event.pointerType !== 'mouse') return;
    const { badge, tip } = activeSpecif;
    if (!badge.contains(event.target) && !tip.contains(event.target)) return;
    if (badge.contains(event.relatedTarget) || tip.contains(event.relatedTarget)) return;
    specifTimer = window.setTimeout(closeSpecif, 180);
  });
  document.addEventListener('focusin', (event) => {
    const badge = event.target.closest('[data-specif-badge]');
    if (badge?.matches(':focus-visible')) openSpecif(badge);
  });
  document.addEventListener('focusout', (event) => {
    if (activeSpecif?.badge === event.target && event.relatedTarget && !activeSpecif.tip.contains(event.relatedTarget)) closeSpecif();
  });
  window.addEventListener('scroll', queueSpecifPosition, { capture: true, passive: true });
  window.addEventListener('resize', queueSpecifPosition, { passive: true });
  window.visualViewport?.addEventListener('resize', queueSpecifPosition, { passive: true });
  window.visualViewport?.addEventListener('scroll', queueSpecifPosition, { passive: true });

  function announce(message) {
    const region = liveRegion();
    if (region) region.textContent = message;
  }

  function showToast(message) {
    const toast = document.getElementById('GommaDotToast');
    if (!toast) return;
    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.setAttribute('aria-hidden', 'false');
    toast.classList.add('is-visible');
    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }, 3200);
  }

  async function refreshCartCount() {
    if (!config.routes || !config.routes.cartJson) return;
    const response = await fetch(config.routes.cartJson, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((bubble) => {
      bubble.textContent = cart.item_count;
      bubble.classList.toggle('is-empty', cart.item_count === 0);
    });
  }

  async function addFormToCart(form, button) {
    if (!config.routes || !config.routes.cartAdd) return false;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(config.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || config.strings.cartError);
      await refreshCartCount();
      const message = config.strings.addedToCart || 'Aggiunto al carrello';
      announce(message);
      showToast(message);
      document.dispatchEvent(new CustomEvent('gommadot:cart-updated', { detail: payload }));
      return true;
    } catch (error) {
      const message = error.message || config.strings.cartError || 'Errore carrello';
      announce(message);
      showToast(message);
      return false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('gommadot:wishlist') || '[]'); }
    catch (_error) { return []; }
  }

  function syncWishlistButtons() {
    const wishlist = new Set(getWishlist());
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(wishlist.has(button.dataset.wishlistToggle)));
    });
  }

  function toggleWishlist(button) {
    const handle = button.dataset.wishlistToggle;
    const wishlist = new Set(getWishlist());
    const willSave = !wishlist.has(handle);
    if (willSave) wishlist.add(handle); else wishlist.delete(handle);
    try { localStorage.setItem('gommadot:wishlist', JSON.stringify(Array.from(wishlist))); }
    catch (_error) { return; }
    button.setAttribute('aria-pressed', String(willSave));
    announce(willSave ? 'Prodotto salvato nei preferiti' : 'Prodotto rimosso dai preferiti');
  }

  function validTyreSize(width, height, diameter) {
    const values = [Number(width), Number(height), Number(diameter)];
    return values.every(Number.isFinite) && values[0] >= 40 && values[0] <= 500 && values[1] >= 20 && values[1] <= 100 && values[2] >= 8 && values[2] <= 30;
  }

  function tyreSize(width, height, diameter) {
    return validTyreSize(width, height, diameter) ? { width, height, diameter } : null;
  }

  function parseTyreSize(value) {
    const query = value.trim().toLowerCase().replace(',', '.');
    const explicit = query.match(/^(\d{2,3})\s*[\/x\- ]\s*(\d{2,3})\s*(?:zr|r|[\- ])\s*(\d{1,2}(?:\.5)?)$/i);
    if (explicit) return tyreSize(explicit[1], explicit[2], explicit[3]);

    const candidates = [];
    if (query.length === 6) candidates.push([query.slice(0, 2), query.slice(2, 4), query.slice(4, 6)]);
    if (query.length === 7) {
      candidates.push([query.slice(0, 3), query.slice(3, 5), query.slice(5, 7)]);
      candidates.push([query.slice(0, 2), query.slice(2, 5), query.slice(5, 7)]);
      if (query.endsWith('5')) candidates.push([query.slice(0, 2), query.slice(2, 4), `${query.slice(4, 6)}.5`]);
    }
    if (query.length === 8) {
      candidates.push([query.slice(0, 3), query.slice(3, 6), query.slice(6, 8)]);
      if (query.endsWith('5')) candidates.push([query.slice(0, 3), query.slice(3, 5), `${query.slice(5, 7)}.5`]);
    }
    if (query.length === 9 && query.endsWith('5')) candidates.push([query.slice(0, 3), query.slice(3, 6), `${query.slice(6, 8)}.5`]);

    for (const candidate of candidates) {
      const parsed = tyreSize(candidate[0], candidate[1], candidate[2]);
      if (parsed) return parsed;
    }
    return null;
  }

  function submitAsTyreSize(form) {
    const input = form.querySelector('input[name="q"]');
    if (!input || !config.filters || !config.routes) return false;
    const size = parseTyreSize(input.value);
    if (!size) return false;
    if (!window.GommaDotTyreSearch) return false;
    const url = window.GommaDotTyreSearch.searchUrl(size.width, size.height, size.diameter, '');
    window.location.assign(url.toString());
    return true;
  }

  function closeMobileFacets(restoreFocus = true) {
    const layout = document.querySelector('[data-shop-layout]');
    if (!layout) return;
    layout.classList.remove('is-facets-open');
    const sidebar = layout.querySelector('.shop-sidebar');
    if (sidebar) {
      sidebar.removeAttribute('role');
      sidebar.removeAttribute('aria-modal');
    }
    if (!document.querySelector('[data-mobile-menu][open]')) document.body.style.removeProperty('overflow');
    const toggle = document.querySelector('[data-facets-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) toggle.focus();
    }
  }

  function focusableElements(container) {
    return Array.from(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),details>summary,[tabindex]:not([tabindex="-1"])')).filter((item) => item.getAttribute('tabindex') !== '-1' && !item.hidden && item.offsetParent !== null);
  }

  let menuOffsetFrame = 0;
  function syncMobileMenuOffset() {
    const openMenu = document.querySelector('[data-mobile-menu][open]');
    if (!openMenu) return;
    const header = document.querySelector('.site-header');
    if (!header) return;
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    openMenu.style.setProperty('--menu-panel-top', `${bottom}px`);
  }

  function queueMobileMenuOffsetSync() {
    if (menuOffsetFrame) return;
    menuOffsetFrame = window.requestAnimationFrame(() => {
      menuOffsetFrame = 0;
      syncMobileMenuOffset();
    });
  }

  function initMobileMenus(root) {
    root.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) {
          syncMobileMenuOffset();
          document.body.style.overflow = 'hidden';
          const first = focusableElements(menu.querySelector('.mobile-menu__panel'))[0];
          if (first) first.focus();
        } else if (!document.querySelector('.shop-layout.is-facets-open')) {
          document.body.style.removeProperty('overflow');
        }
      });
    });
  }

  window.addEventListener('scroll', queueMobileMenuOffsetSync, { passive: true });
  window.addEventListener('resize', queueMobileMenuOffsetSync, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', queueMobileMenuOffsetSync, { passive: true });

  const mobileFooter = window.matchMedia('(max-width: 749px)');
  function syncFooterDisclosures(event = mobileFooter, root = document) {
    root.querySelectorAll('[data-footer-disclosure]').forEach((disclosure) => {
      const summary = disclosure.querySelector(':scope > summary');
      if (event.matches) {
        if (disclosure.dataset.mobileReady) return;
        disclosure.open = false;
        disclosure.dataset.mobileReady = 'true';
        if (summary) {
          summary.removeAttribute('tabindex');
          summary.removeAttribute('aria-disabled');
        }
      } else {
        disclosure.open = true;
        delete disclosure.dataset.mobileReady;
        if (summary) {
          summary.setAttribute('tabindex', '-1');
          summary.setAttribute('aria-disabled', 'true');
        }
      }
    });
  }
  if (mobileFooter.addEventListener) mobileFooter.addEventListener('change', syncFooterDisclosures);
  else mobileFooter.addListener(syncFooterDisclosures);

  const desktopHeader = window.matchMedia('(min-width: 901px)');
  function closeMobileMenuOnDesktop(event) {
    if (!event.matches) return;
    document.querySelectorAll('[data-mobile-menu][open]').forEach((menu) => { menu.open = false; });
    if (!document.querySelector('.shop-layout.is-facets-open')) document.body.style.removeProperty('overflow');
  }
  if (desktopHeader.addEventListener) desktopHeader.addEventListener('change', closeMobileMenuOnDesktop);
  else desktopHeader.addListener(closeMobileMenuOnDesktop);

  const desktopFacets = window.matchMedia('(min-width: 1024px)');
  function closeMobileFacetsOnDesktop(event) {
    if (!event.matches) return;
    const layout = document.querySelector('[data-shop-layout]');
    if (layout?.classList.contains('is-facets-open')) closeMobileFacets(false);
  }
  if (desktopFacets.addEventListener) desktopFacets.addEventListener('change', closeMobileFacetsOnDesktop);
  else desktopFacets.addListener(closeMobileFacetsOnDesktop);

  document.addEventListener('error', (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.matches('[data-static-brand-logo]')) return;
    const wrapper = image.closest('[data-brand-logo]');
    if (wrapper) wrapper.classList.add('is-fallback');
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('[data-native-search]')) {
      const input = form.querySelector('input[name="q"]');
      if (input?.dataset.exactQuery && input.value.trim() === input.defaultValue.trim()) {
        input.value = input.dataset.exactQuery;
      } else if (submitAsTyreSize(form)) {
        event.preventDefault();
      } else if (input) {
        input.value = config.exactSearchQuery(input.value);
      }
      return;
    }

    if (form.matches('[data-clean-empty-fields]')) {
      form.querySelectorAll('input,select').forEach((field) => {
        if (!field.value && field.name) field.disabled = true;
      });
    }

    if (form.matches('[data-quick-add]')) {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button) addFormToCart(form, button);
    }
  });

  document.addEventListener('input', (event) => {
    const search = event.target.closest('[data-facet-value-search]');
    if (!search) return;
    const query = search.value.trim().toLocaleLowerCase();
    const facet = search.closest('.facet');
    if (!facet) return;
    const more = facet.querySelector('.facet-more');
    if (more && query) more.open = true;
    facet.querySelectorAll('[data-filter-value]').forEach((value) => {
      value.hidden = Boolean(query) && !value.dataset.filterValue.includes(query);
    });
  });

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('[data-quantity]');
      const input = wrapper ? wrapper.querySelector('input[type="number"]') : null;
      if (input) {
        const direction = Number(quantityButton.dataset.quantityChange);
        const current = Number(input.value || 1);
        const min = Number(input.min || 1);
        const max = Number(input.max || 99);
        input.value = String(Math.min(max, Math.max(min, current + direction)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const wishlistButton = event.target.closest('[data-wishlist-toggle]');
    if (wishlistButton) {
      event.preventDefault();
      toggleWishlist(wishlistButton);
      return;
    }

    const specifBadge = event.target.closest('[data-specif-badge]');
    if (specifBadge) {
      event.preventDefault();
      if (activeSpecif?.badge === specifBadge && activeSpecif.pinned) closeSpecif();
      else openSpecif(specifBadge, true);
      return;
    }
    if (!activeSpecif?.tip.contains(event.target)) closeSpecif();

    const mobileMenuClose = event.target.closest('[data-mobile-menu-close]');
    if (mobileMenuClose) {
      const menu = mobileMenuClose.closest('[data-mobile-menu]');
      if (menu) {
        menu.open = false;
        const summary = menu.querySelector(':scope > summary');
        if (summary) summary.focus();
      }
      return;
    }

    const facetsToggle = event.target.closest('[data-facets-toggle]');
    if (facetsToggle) {
      const layout = document.querySelector('[data-shop-layout]');
      if (!layout) return;
      layout.classList.add('is-facets-open');
      const sidebar = layout.querySelector('.shop-sidebar');
      if (sidebar) {
        sidebar.setAttribute('role', 'dialog');
        sidebar.setAttribute('aria-modal', 'true');
      }
      document.body.style.overflow = 'hidden';
      facetsToggle.setAttribute('aria-expanded', 'true');
      const close = layout.querySelector('.shop-sidebar [data-facets-close]');
      if (close) close.focus();
      return;
    }

    if (event.target.closest('[data-facets-close]')) closeMobileFacets();
  });

  document.addEventListener('keydown', (event) => {
    const facetModal = document.querySelector('.shop-layout.is-facets-open .shop-sidebar');
    const openMenu = document.querySelector('[data-mobile-menu][open]');
    const brandModal = document.querySelector('[data-brand-picker-panel]:not([hidden])');
    const activeModal = brandModal || facetModal || (openMenu ? openMenu.querySelector('.mobile-menu__panel') : null);

    if (event.key === 'Tab' && activeModal) {
      const focusable = focusableElements(activeModal);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      return;
    }

    if (event.key !== 'Escape' || brandModal) return;
    closeSpecif();
    if (facetModal) closeMobileFacets();
    if (openMenu) {
      openMenu.open = false;
      const summary = openMenu.querySelector(':scope > summary');
      if (summary) summary.focus();
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    syncWishlistButtons();
    initMobileMenus(event.target);
    syncFooterDisclosures(mobileFooter, event.target);
  });
  document.addEventListener('gommadot:content-updated', syncWishlistButtons);
  initMobileMenus(document);
  syncFooterDisclosures();
  closeMobileMenuOnDesktop(desktopHeader);
  closeMobileFacetsOnDesktop(desktopFacets);
  syncWishlistButtons();

  window.GommaDotTheme = { announce, showToast, refreshCartCount, addFormToCart, closeMobileFacets, parseTyreSize };
})();
